export default "__VITE_ASSET__BDhCTLtZ__"